// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"6f2a1997","497":"358a96fd"}[chunkId] + ".chunk.css";
};